import { AUTH_TOKEN_NAME } from '@/config'

// Try to authenticate user if auth token is present and user is not already authenticated.
export default async function tryAuthenticate ({ store, nextMiddleware }) {
  if (!store.user.isAuthenticated && localStorage.getItem(AUTH_TOKEN_NAME)) {
    await store.user.requestProfile()
  }

  return nextMiddleware()
}
